import { Icon } from '~/components';

import { useGetDdexDownloadLink } from '../api/queries/useGetDdexDownloadLink';

interface DownloadDdexInfoProps {
  id: string;
}

export function DownloadDdexInfo({ id }: DownloadDdexInfoProps) {
  const { data, refetch, isFetching } = useGetDdexDownloadLink(id);

  const handleDownload = async () => {
    try {
      if (!data && !isFetching) {
        await refetch();
      }

      if (data?.presigned_url) {
        window.open(data.presigned_url, '_blank');
      }
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <Icon
      type="arrow-down-to-line"
      variant="light"
      className="ml-sm text-hover"
      size="md"
      data-testid="download-icon"
      onClick={handleDownload}
    />
  );
}

DownloadDdexInfo.displayName = 'DownloadDdexInfo';
